module.exports = __webpack_public_path__ + "stripe-card-icon.png?f7e619a5443c7f2f472b330f2e86996c";